import type { AudioRegionParams } from "@/components/audio-player/AudioPlayer"
import type {
  MetricOutputDisplaySource,
  RunMetricOutput,
} from "@/types/RunMetricOutput"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"
import { WithAudioGateMixin } from "../mixins/WithAudioGateMixin"

export class TimeToFirstAudioMetricRecord extends WithAudioGateMixin(
  NumericalMetricRecord,
) {
  overviewSize = "medium" as const
  unit = "ms"
  aggregate_units = "ms"

  _renderDeepDive(mo: RunMetricOutput): React.ReactNode {
    const timeToFirstData = mo.result_json as {
      timestamp: string
      time_to_first_audio_ms: number
      first_speaker: string
    }

    if (!timeToFirstData) {
      return <div>No detailed time to first audio data available</div>
    }

    const timeToFirstAudioMs = timeToFirstData.time_to_first_audio_ms

    return (
      <div key={this.metric_name} className="w-full">
        <div className="mb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-content2 rounded-md">
              <div className="text-sm opacity-70">Time To First Audio</div>
              <div className="text-xl font-semibold">
                {timeToFirstAudioMs != null
                  ? `${Math.round(timeToFirstAudioMs)} ms`
                  : "N/A"}
              </div>
            </div>
            <div className="p-4 bg-content2 rounded-md">
              <div className="text-sm opacity-70">First Speaker</div>
              <div className="text-xl font-semibold">
                {timeToFirstData.first_speaker || "N/A"}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  getAudioRegions(mo: MetricOutputDisplaySource): AudioRegionParams[] {
    if (mo?.error_message && mo?.error_message !== "") {
      return []
    }
    try {
      const data = mo.result_json as {
        time_to_first_audio_ms?: number
      }
      const ms = data?.time_to_first_audio_ms ?? mo.float_value
      if (ms == null || ms <= 0) {
        return []
      }
      const seconds = ms / 1000
      return [
        {
          id: "ttfa:0",
          start: 0,
          end: Math.max(seconds, 0.1),
          color: "rgba(59, 130, 246, 0.3)",
          drag: false,
          resize: false,
        },
      ]
    } catch {
      return []
    }
  }
}
